<template>
    <div>
        <p>找不到此頁面，請確認是否為有效網址。</p>
        <div class="mt-4 text-center">
            <router-link :to="{ name: routeName.HOME }">
                <button class="btn gradient-primary rounded-full">
                    回首頁
                </button>
            </router-link>
        </div>
    </div>
</template>
<script>
import routeName from '@/router/constant.js';
export default {
    setup() {
        return { routeName };
    }
};
</script>
